/* Sleep homepage — Airway120 Max. The pulse rings are pure CSS; this only pauses them while the pod is off screen.
   No JS / no IntersectionObserver = the rings simply keep running. Reduced motion = static rings (CSS). */
(function () {
  'use strict';
  var DTS = (window.DTS = window.DTS || {});
  function init() {
    var stage = document.querySelector('#dts-airway [data-dts-airway-stage]');
    if (!stage) return;
    if (!('IntersectionObserver' in window)) { stage.classList.add('is-live'); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { stage.classList.toggle('is-live', en.isIntersecting); });
    }, { rootMargin: '10% 0px' }).observe(stage);
  }
  if (typeof DTS.register === 'function') DTS.register('airway', init);
  else { DTS.modules = DTS.modules || []; DTS.modules.push({ name: 'airway', fn: init }); }
})();
